export * from './TablePaginationLabel';
